package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton

@Composable
fun LoginSubmitButton(
    tvTitle: String,
    buttonTitle: String,
    isClickable:Boolean,
    loading: Boolean,
    onButtonClick: () -> Unit,
    onTitleClick:()->Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        CustomButton(
            modifier = Modifier.fillMaxWidth(),
            isClickable =isClickable,
            loading = loading,
            title =buttonTitle ,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick ={
                onButtonClick()
            },
        )

        CustomButton(
            modifier = Modifier
                .margin(topBottom = Dimen.smallPadding) ,
            title =tvTitle ,
            buttonType = ButtonTypes.TEXT,
            onButtonClick ={
                onTitleClick()
            },
        )


    }

}
